var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "div",
        {
          staticClass: "cs-app",
          class: _vm.$route.name,
          attrs: { id: "cs-app" },
        },
        [
          _c("cs-header", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.routeHasHeader,
                expression: "routeHasHeader",
              },
            ],
            attrs: {
              "header-logo": _vm.headerLogo,
              "menu-expanded": _vm.menuExpanded,
              "active-component": _vm.activeComponent,
              user: _vm.user,
              "home-url": _vm.homeUrl,
              isRouteHasHeader: _vm.routeHasHeader,
              "root-level-help-text": _vm.rootLevelHelpText,
              "entity-level-help-text": _vm.entityLevelHelpText,
              progress: _vm.progress,
              "has-notifications": _vm.appHasNotifications,
            },
            on: {
              toggleSidebar: _vm.toggleSidebar,
              toggleNotifications: _vm.toggleNotificationCenter,
              showNotification: _vm.showNotification,
            },
          }),
          _c(
            "div",
            { staticClass: "cs-app-container" },
            [
              _vm.routeHasSidebar
                ? _c("cs-sidebar", {
                    attrs: {
                      "menu-expanded": _vm.menuExpanded,
                      user: _vm.user,
                      "last-activity": _vm.lastActivity,
                    },
                    on: {
                      showNotification: _vm.showNotification,
                      toggleSidebar: _vm.toggleSidebar,
                      sidebarTransitionEnd: _vm.onSidebarTransitionEnd,
                    },
                    model: {
                      value: _vm.siteStructure,
                      callback: function ($$v) {
                        _vm.siteStructure = $$v
                      },
                      expression: "siteStructure",
                    },
                  })
                : _vm._e(),
              _c(
                "main",
                {
                  staticClass: "cs-container",
                  class: { "cs-sidebar-expanded": _vm.menuExpanded },
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "loading" } },
                    [
                      _vm.routeHasView
                        ? _c("router-view", {
                            attrs: {
                              user: _vm.user,
                              entities: _vm.siteStructure.subEntities,
                              navigation: _vm.siteStructure.navigation,
                              theme: _vm.theme,
                              "header-logo": _vm.headerLogo,
                              screen: _vm.screen,
                              "is-page": true,
                              "in-page-component-edit-version":
                                _vm.inPageComponentEditVersion,
                              "root-level-help-text": _vm.rootLevelHelpText,
                            },
                            on: {
                              showNotification: _vm.showNotification,
                              setupSession: _vm.setupSession,
                              setActiveComponent: _vm.onSetActiveComponent,
                              updateTheme: _vm.updateTheme,
                              updateComponentVersion:
                                _vm.updateComponentVersion,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("mq-layout", { attrs: { mq: "sm" } }, [
                _vm.menuExpanded
                  ? _c("div", { staticClass: "cs-overlay" })
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm.isVisible ? _c("cs-loadingbar") : _vm._e(),
          _vm.isVisible ? _c("cs-notifications-center") : _vm._e(),
          _vm.isVisible
            ? _c("cs-systemmessages", {
                attrs: {
                  errors: _vm.userErrors,
                  notifications: _vm.notifications,
                  "standard-page-error-message":
                    _vm.$root.$data.config.standardPageErrorMessage,
                },
                on: {
                  dismissError: _vm.dismissError,
                  dismissNotification: _vm.dismissNotification,
                  setNotificationData: _vm.onSetNotificationData,
                },
              })
            : _vm._e(),
          _vm.isSystemFormVisible
            ? _c("cs-system-form", {
                attrs: {
                  "forms-data-object": _vm.formsDataObject,
                  "container-blur": true,
                },
              })
            : _vm._e(),
          _vm.isSystemExportFormVisible
            ? _c("cs-system-exportform", {
                attrs: {
                  "forms-data-object": _vm.formsDataObject,
                  "container-blur": true,
                },
              })
            : _vm._e(),
          _c("cs-system-tooltip"),
          _c("cs-system-popup", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSystemPopupVisible,
                expression: "isSystemPopupVisible",
              },
            ],
            attrs: {
              "system-popup-options": _vm.systemPopupOptions,
              "is-system-popup-visible": _vm.isSystemPopupVisible,
            },
            on: {
              dismissPopup: function ($event) {
                return _vm.onDismissSystemPopup(...arguments)
              },
            },
          }),
          _vm.isNavPopupVisible
            ? _c("cs-navigation-popup", {
                attrs: {
                  "entity-url": _vm.navigationPopupEntityUrl,
                  items: _vm.navigationPopupItems,
                  target: _vm.navigationPopupTarget,
                },
              })
            : _vm._e(),
          _c("cs-datepicker-modal"),
          _c("div", {
            staticClass: "cs-offline-routing",
            class: { "cs-online-routing": !_vm.platformFrozen },
            on: { click: _vm.onNotifiyNoInternet },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }